import React, { Component } from 'react'
// import PropTypes from 'prop-types'

class About extends Component {
  render() {
    return (
      <div className="content">
        <div className="about">
          <p>
            <span className="header">Who</span>
          </p>

          <p>
            I'm James.
          </p>

          <p>
            <a href='https://twitter.com/jamisnemo'>Twitter: jamisnemo</a> <br/>
            <a href='https://github.com/jameshagerman'>GitHub: JamesHagerman</a>
          </p>

          <p>
            <span className="header">What</span>
          </p>

          <p>This is my page; a notebook of some kind. I will post here, what I want.</p>


          {/*<div>*/}
            {/*<span class="header">Links</span>*/}
          {/*</div>*/}
          {/*<ul>*/}
            {/*<li><a href="http://www.codingwithcody.com/">About</a></li>*/}
          {/*</ul>*/}
          {/*<ul>*/}
            {/*<li><a href="http://www.codingwithcody.com/">Codying with Cody</a></li>*/}
            {/*<li><a href="http://blog.crashspace.org/">Crash Space</a></li>*/}
            {/*<li><a href="http://032.la/">Null Space Labs</a></li>*/}
            {/*<li><a href="http://explo.it">Explo.it</a></li>*/}
            {/*<li><a href="http://forums.remote-exploit.org/">Remote-Exploit Forums</a></li>*/}
            {/*<li><a href="http://www.sparkfun.com/">SparkFun Electronics</a></li>*/}
            {/*<li><a href="http://dangerousprototypes.com/">Dangerous Prototypes/</a></li>*/}
            {/*<li><a href="http://www.adafruit.com/">Adafruit Industries</a></li>*/}
            {/*<li><a href="http://www.seeedstudio.com/depot/">Seeed Studio Depot</a></li>*/}
            {/*<li><a href="http://railsforzombies.org/">Rails for Zombies</a></li>*/}
            {/*<li><a href="http://tryruby.org/">Try Ruby!</a></li>*/}
          {/*</ul>*/}

        </div>
      </div>
    )

  }
}

export default About



// WEBPACK FOOTER //
// ./src/components/About/index.js